/**
 * Validates `window.location.pathname` before syncing in-memory router state.
 *
 * Rejects values that are not normal in-app paths (e.g. protocol-relative URLs, `blob:` URLs,
 * or pathnames containing `http(s)://` segments). **Do not** use a character-length limit: real
 * enterprise deep links can exceed arbitrary thresholds and must still sync correctly.
 */
export function isSafePathname(p: string): boolean {
  if (typeof p !== 'string' || p.length === 0) return false;
  if (!p.startsWith('/')) return false;
  if (p.startsWith('//')) return false;
  const lower = p.toLowerCase();
  if (lower.startsWith('/blob:')) return false;
  // Path segments that look like an absolute URL (mis-routed or sandbox oddities)
  if (/(?:^|\/)https?:\/\//i.test(p)) return false;
  return true;
}
